import { C } from '../data/constants.js';

export class Paddle {
  constructor() {
    this.w = C.PADDLE_W;
    this.h = C.PADDLE_H;
    this.x = C.CANVAS_W / 2;  // center X of paddle
    this.y = C.PADDLE_Y;
    this.prevX = this.x;
    this.velocity = 0;         // calculated each frame for spin
    this.animPhase = 0;        // animated pulse timer
  }

  update(input) {
    this.prevX = this.x;
    this.animPhase += 0.05;
    
    // Touch/mouse: follow pointer directly
    if (input.pointerActive) {
      this.x = input.pointerX;
    }
    
    // Keyboard fallback
    if (input.left)  this.x -= C.PADDLE_SPEED;
    if (input.right) this.x += C.PADDLE_SPEED;
    
    // Clamp to canvas bounds
    this.x = Math.max(this.w / 2, Math.min(C.CANVAS_W - this.w / 2, this.x));
    
    // Calculate velocity for spin system
    this.velocity = this.x - this.prevX;
  }

  get left()   { return this.x - this.w / 2; }
  get right()  { return this.x + this.w / 2; }
  get top()    { return this.y - this.h / 2; }
  get bottom() { return this.y + this.h / 2; }

  render(ctx) {
    const x = this.left;
    const y = this.top;
    const w = this.w;
    const h = this.h;
    const speed = Math.min(1, Math.abs(this.velocity) / 6);

    ctx.save();

    // 1. Dynamic Under-Glow & Thruster Plasma
    const pulseGlow = 10 + Math.sin(this.animPhase * 2) * 3 + speed * 8;
    ctx.shadowColor = speed > 0.3 ? '#00ffff' : '#00aaff';
    ctx.shadowBlur = pulseGlow;

    // Thruster exhaust underneath when moving
    if (Math.abs(this.velocity) > 0.5) {
      const dir = Math.sign(this.velocity);
      const exhaustLen = 6 + speed * 10;
      const gradExhaust = ctx.createLinearGradient(this.x, y + h, this.x - dir * 15, y + h + exhaustLen);
      gradExhaust.addColorStop(0, 'rgba(0, 255, 255, 0.8)');
      gradExhaust.addColorStop(1, 'rgba(0, 150, 255, 0)');

      ctx.fillStyle = gradExhaust;
      ctx.beginPath();
      ctx.moveTo(this.x - dir * 8, y + h);
      ctx.lineTo(this.x + dir * 8, y + h);
      ctx.lineTo(this.x - dir * (8 + exhaustLen), y + h + exhaustLen);
      ctx.closePath();
      ctx.fill();
    }

    // 2. Main Cyber Chassis Base (Rounded Chamfered Hex-Bar)
    const r = 5;
    const bodyGrad = ctx.createLinearGradient(x, y, x, y + h);
    bodyGrad.addColorStop(0, '#10334c');
    bodyGrad.addColorStop(0.3, '#00e5ff');
    bodyGrad.addColorStop(0.5, '#ffffff');
    bodyGrad.addColorStop(0.7, '#00b8d4');
    bodyGrad.addColorStop(1, '#00364a');

    ctx.fillStyle = bodyGrad;
    ctx.beginPath();
    ctx.roundRect(x, y, w, h, r);
    ctx.fill();

    // Outer Neon Border
    ctx.strokeStyle = '#00ffff';
    ctx.lineWidth = 1.5;
    ctx.stroke();
    ctx.shadowBlur = 0;

    // 3. Wingtip End-Caps (Reinforced Kinetic Dampeners)
    const capW = Math.max(7, w * 0.1);
    // Left cap
    ctx.fillStyle = '#002538';
    ctx.beginPath();
    ctx.roundRect(x + 1, y + 1, capW, h - 2, [r - 1, 0, 0, r - 1]);
    ctx.fill();
    // Left diode beacon
    ctx.fillStyle = speed > 0.2 ? '#ffffff' : '#00ffff';
    ctx.fillRect(x + 3, y + 3, 2, h - 6);

    // Right cap
    ctx.fillStyle = '#002538';
    ctx.beginPath();
    ctx.roundRect(x + w - capW - 1, y + 1, capW, h - 2, [0, r - 1, r - 1, 0]);
    ctx.fill();
    // Right diode beacon
    ctx.fillStyle = speed > 0.2 ? '#ffffff' : '#00ffff';
    ctx.fillRect(x + w - 5, y + 3, 2, h - 6);

    // 4. Center Glowing Plasma Rail & Micro-Segments
    const coreW = w - (capW * 2) - 8;
    const coreX = x + capW + 4;
    const coreY = y + h / 2 - 1.5;

    // Segmented reflector notches along top rail
    ctx.fillStyle = 'rgba(0, 0, 0, 0.4)';
    const notchCount = Math.max(3, Math.floor(w / 14));
    const notchSpacing = coreW / notchCount;
    for (let i = 1; i < notchCount; i++) {
      ctx.fillRect(coreX + i * notchSpacing - 0.5, y + 1, 1, 3);
    }

    // Core Plasma Rail
    ctx.fillStyle = 'rgba(255, 255, 255, 0.9)';
    ctx.shadowColor = '#ffffff';
    ctx.shadowBlur = 4;
    ctx.beginPath();
    ctx.roundRect(coreX + 4, coreY, coreW - 8, 3, 1.5);
    ctx.fill();
    ctx.shadowBlur = 0;

    // 5. Glossy Top Specular Highlight
    ctx.fillStyle = 'rgba(255, 255, 255, 0.4)';
    ctx.beginPath();
    ctx.roundRect(x + capW + 2, y + 1.5, w - (capW * 2) - 4, 2, 1);
    ctx.fill();

    ctx.restore();
  }
}
